<template>  
  <div class="XR-top">
    <div>
      <div class="XR-top-bg" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
        <div class="headimgDiv">
            <img :src="url" class="headpic" />
        </div>
      </div>
      <!-- <p class="loginBtn" v-if="ShowName">嘿嘿嘿</p>            -->
    </div>
  </div>
</template>

<script>
export default {
  name : 'XR-top',
  data () {
    return {
      url : this.imgUrl ? this.imgUrl : 'http://frontend.xurigo.com/icon/person.jpg',      
      siteConfig:{ MobileBgImage : '' }
    }
  },
  props:{
    imgUrl: String,
    icon : String
  },
  mounted(){
    this.getSiteInfo()
  },
  methods: {       
    getSiteInfo: function () {    
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
        .then(function (res) {
          if(res.IsSuccess){
            ths.siteConfig = res.Data
          }         
        })
        .catch(function (err) {
          console.log(err)
        })    
    },    
  }
}
</script>

<style>
.XR-top{
  min-height: 115px;
  overflow:hidden;
  background:white;
}
  .XR-top .XR-top-bg {
      width: 100%;
      height: 75px;
      display: block;
      background: url(/static/us-top-bg.png);
      padding: 35px 0 0;
  }
  .XR-top .headimgDiv 
  {
      margin:0 auto; 
      width:70px;
      height:70px;
      border-radius:50%; 
      border:4px solid white;
      overflow:hidden;
      text-align: center;
      background: #E6BC5A;
  }
  
  .XR-top .headimgDiv .fa{
    font-size: 30px;
    line-height: 58px;
    color:white;
  }
.XR-top .headpic { display:block; width:100%; }
.XR-top .loginBtn { text-align:center; color:#999; font-size:12px; padding:30px 0 4px;}

</style>



// WEBPACK FOOTER //
// src/components/usercenter/top/top.vue